import { FC } from 'react';

import { dom } from 'app/utils';
import { InputSwitch as Component, InputSwitchProps as Props } from '../external';
import { IInput } from './types';

export interface ISwitch extends IInput {
  checked?: boolean;
}

export const Switch: FC<ISwitch> = ({ id, className, style, disabled, name, value, invalid, tabIndex, placeholder, tooltip, autoFocus, checked, onBlur, onChange, onFocus }) => {
  const component: Props = { id, style, disabled, name, value, invalid, tabIndex, placeholder, tooltip, autoFocus, onBlur, onFocus,
    checked: !!(checked ?? value),
    className: dom.className('i-component', 'i-input', 'i-inline', 'i-switch', { 'i-invalid': invalid }, className),
    onChange: onChange as any,
  };

  return (
    <Component { ...component } />
  );
}
